/**
 * Tool failures the clinician can act on in the transcript: connect an app.
 * Everything else, including desktop-required misses, is agent-facing — the
 * model already has the result and tells the clinician in its reply.
 */

import type { DesktopRequiredScanItem } from '../../../contracts/desktop-required.types';
import { isRecord } from '../../../contracts/parse-utils';

export const isClinicianActionableToolError = (
  item: DesktopRequiredScanItem
): boolean => {
  const data = item.result_provider_metadata?.data;
  return isRecord(data) && data.code === 'connect_required';
};
